export function useUrlParams() {
  const params = new URLSearchParams(window.location.search)
  return {
    sessionId: params.get('session_id') || undefined,
    mode: params.get('mode') || undefined,
    transmission: params.get('transmission') || undefined,
    character: params.get('character') || undefined,
    story: params.get('story') || undefined,
    features: params.get('features') || undefined,
  }
}
